import React, { useEffect, useMemo, useRef } from 'react';
import { Container, Sprite } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import { gameResourcesService } from '../../../services/gameResourcesService';

import { Spine } from '../../../core/classes/spine';
import { isMobile } from '../../../core/helpers/isMobile';
import { getGameImages } from '../../../core/helpers/getGameImages';

const GameMainBackground = observer(({ bgConfig }) => {
  const dustRef = useRef();
  const backgroundRef = useRef(null);

  const { background } = useMemo(() => {
    return getGameImages();
  }, []);

  useEffect(() => {
    if (backgroundRef.current && !isMobile()) {
      const dustSpine = new Spine({ key: 'dust' });
      dustSpine.x = 720;
      dustSpine.y = 405;
      gameResourcesService.setDustSpine(dustSpine);
      dustRef.current.addChild(dustSpine);
    } else if (backgroundRef.current && isMobile()) {
      backgroundRef.current.width = window.innerWidth;
      backgroundRef.current.height = window.innerHeight;
    }
  }, []);

  return (
    <Container {...bgConfig} name='MainBackground'>
      <Sprite texture={background} ref={backgroundRef} />
      <Container ref={dustRef} name='DustContainer' />
    </Container>
  );
});

export default GameMainBackground;
